import { Controller } from "@hotwired/stimulus"
import { ehaz_sync_status_path, ehaz_sync_finalize_path, root_path } from "../routes"

// Connects to data-controller="ehaz-sync"
export default class extends Controller {
  static values = { token: String }
  static targets = [ 'error', 'backgroundNotice', 'result', 'failedList' ]

  connect() {
    this.startTime = Date.now()
    this.successHandled = false
    this.pollUntilReady()
  }

  async pollUntilReady() {
    const backoffMs = [500, 1000, 1500, 2000, 3000]
    let i = 0
    // Poll indefinitely; increase delay until max, then keep using max
    // to avoid spamming while still progressing when ready
    while (true) {
      // Show background notice after 2 minutes
      const elapsed = Date.now() - this.startTime
      if (elapsed > 120000 && this.hasBackgroundNoticeTarget) {
        this.backgroundNoticeTarget.classList.remove('d-none')
      }

      const ok = await this.checkStatus()
      if (ok) return
      const delay = i < backoffMs.length ? backoffMs[i] : backoffMs[backoffMs.length - 1]
      await new Promise(r => setTimeout(r, delay))
      if (i < backoffMs.length) i++
    }
  }

  async checkStatus() {
    try {
      const url = ehaz_sync_status_path({ token: this.tokenValue })
      const res = await fetch(url, { method: 'GET' })
      if (!res.ok) return false
      const data = await res.json()
      const state = data?.status?.state
      const failedHouses = data?.status?.failed_houses || []
      if (state === 'success_with_errors') {
        this.showFailedResults(failedHouses)
        return true
      } else if (state === 'success') {
        const finalized = await this.finalizeSync()
        if (finalized) {
          window.location.href = '/'
          return true
        }
      } else if (state === 'finalized') {
        window.location.href = '/'
        return true
      } else if (state === 'error') {
        this.showError()
        return true
      }
      return false
    } catch (e) {
      console.error('status error', e)
      return false
    }
  }

  showError() {
    if (this.hasErrorTarget) this.errorTarget.classList.remove('d-none')
  }

  showFailedResults(failedHouses) {
    if (!this.hasResultTarget || this.successHandled) return
    this.successHandled = true
    this.resultTarget.classList.remove('d-none')
    if (this.hasErrorTarget) this.errorTarget.classList.add('d-none')
    if (this.hasBackgroundNoticeTarget) this.backgroundNoticeTarget.classList.add('d-none')

    if (this.hasFailedListTarget) {
      this.failedListTarget.innerHTML = ''
      failedHouses.forEach((house) => {
        const item = document.createElement('li')
        item.className = 'mb-2'

        const nameParts = []
        if (house.ehaz_house_name) nameParts.push(house.ehaz_house_name)
        else if (house.ehaz_house_id) nameParts.push(`#${house.ehaz_house_id}`)
        if (house.building_complex_name) nameParts.push(`– ${house.building_complex_name}`)
        if (house.building_complex_address) nameParts.push(`(${house.building_complex_address})`)
        item.textContent = nameParts.join(' ')

        if (house.error) {
          const errorLine = document.createElement('div')
          errorLine.className = 'small text-danger mt-1'
          errorLine.textContent = house.error
          item.appendChild(errorLine)
        }

        this.failedListTarget.appendChild(item)
      })
    }
  }

  async finishWithErrors(event) {
    event.preventDefault()
    const button = event?.currentTarget
    if (button) {
      button.disabled = true
    }
    const finalized = await this.finalizeSync()
    if (finalized) {
      window.location.href = '/'
    } else {
      if (button) button.disabled = false
      this.showError()
    }
  }

  async finalizeSync() {
    try {
      const response = await fetch(ehaz_sync_finalize_path(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: this.tokenValue })
      })
      return response.ok
    } catch (error) {
      console.error('finalize error', error)
      return false
    }
  }

  goBack() {
    window.location.href = root_path()
  }
}


